import { BsInfoCircleFill } from 'react-icons/bs'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
  PopoverBody,
  Link,
  PopoverArrow,
} from '@chakra-ui/react'
import React from 'react'

interface Props {
  info: string
  link?: string
  hyperlink?: string
}

export const InfoPopover = (props: Props): React.ReactElement => {
  const { info, link, hyperlink } = props

  return (
    <Popover placement="right" trigger="click">
      <PopoverTrigger>
        <BsInfoCircleFill color="#9da3ae" style={{ cursor: 'help' }} />
      </PopoverTrigger>
      <PopoverContent>
        <PopoverArrow />
        <PopoverBody>
          {info}
          {link && hyperlink && (
            <Link href={link} isExternal>
              {' '}
              {hyperlink}
            </Link>
          )}
        </PopoverBody>
      </PopoverContent>
    </Popover>
  )
}
